import { useTranslation } from 'react-i18next';
import Password from '../../../../../../common/widgets/Password';
import { CompanyModel } from '../../../../models/Company';
import { resources } from '../../../../resources/resources';
import Icons from '../../../../../../common/widgets/Icons';
import { showSuccessToast } from '../../../../../../common/global/helpers';
import CopyToClipboard from 'react-copy-to-clipboard';

interface IChangePasswordProps {
  company: CompanyModel;
  parentStateSetter: (company: CompanyModel) => void;
}
export default function ChangePassword(props: Readonly<IChangePasswordProps>) {
  const { t: translate } = useTranslation();
  const { company } = props;

  return (
    <div className="cs-section">
      <div className="cs-title">
        <h4>{translate(resources.admin.companies.passwordSection.title)}</h4>
      </div>
      <div className="cs-content cs-content-fields">
        <Password value={company.password} disabled={true} />
        <CopyToClipboard text={company.password ?? ''}>
          <button
            className="btn btn-password-copy"
            type="button"
            onClick={() => {
              showSuccessToast(translate(resources.clipboardCopied));
            }}
          >
            <Icons.CopyClipboardIcon />
          </button>
        </CopyToClipboard>
      </div>
    </div>
  );
}
